import React, { useEffect, useContext } from "react";
import LanguageContext from "context/context-language";
let iconos = [
    <img src={require("../assets/img/productos/keep_running/camara.svg").default} style={{width: '25px', marginRight: '10px'}}/>, 
    <img src={require("../assets/img/productos/keep_running/reinicio.svg").default} style={{width: '25px', marginRight: '10px'}}/>, 
    <img src={require("../assets/img/productos/keep_running/modem.svg").default} style={{width: '25px', marginRight: '10px'}}/>,     
    <img src={require("../assets/img/productos/keep_running/volt-f.svg").default} style={{width: '25px', marginRight: '10px'}}/>, 
    <img src={require("../assets/img/productos/keep_running/alertas.svg").default} style={{width: '25px', marginRight: '10px'}}/>, 
    <img src={require("../assets/img/productos/keep_running/onoff.svg").default} style={{width: '25px', marginRight: '10px'}}/>, 
    
]
let textos = {
    es: [
        {
            seccion1: [
                "Empresas",
                "Auto-Recovery para Internet de Sucursales",
                "La mayoría de las fallas de red en sucursales se resuelven reiniciando el router. Nuestro equipo lo hace automáticamente sin enviar un técnico.",
                [
                    ["Recupera la red de cámaras de seguridad de tu sucursal.", iconos[0]],
                    ["Restablece el funcionamiento de tus equipos.", iconos[1]]
                ]
            ],
            seccion2: [
                "Hogar",
                "Tu casa siempre conectada, estés donde estés",
                "Con nuestro enchufe inteligente, puedes reiniciar y controlar tus dispositivos clave en cualquier momento y desde cualquier lugar. Usa tus datos móviles solo cuando estés fuera de casa",
                "¿Qué puedes controlar?",
                [
                    "Cámaras de seguridad: asegúrate de que siempre estén activas.",
                    // "Aire acondicionado: evita fallas y mantén el control a distancia.",
                    "Wifi: reinicia tu red en segundos, sin moverte",
                    // "Luces o lámparas: simula presencia en casa cuando estás fuera."
                ]

            ],
            seccion3: [
                "¿Cómo funciona?",
                "Solo conecta tus equipos al enchufe inteligente y desde la app podrás:",
                [
                    ["Vigilar que tu internet está funcionando", iconos[2]],
                    ["Asegurar que tus cámaras de seguridad  están online", iconos[0]],
                    ["Monitoreo de voltajes fuera de rango", iconos[3]],
                    // "Vigilar que la temperatura y humedad son correctas ",
                    ["Recibir alertas si algo deja de funcionar", iconos[4]],
                    // "Programar reinicios automáticos",
                    ["Encender o apagar dispositivos automáticamente en caso de falla", iconos[5]]
                ],
                // "Tu casa trabaja por ti. No importa si estás de viaje, en la oficina o simplemente descansando."
            ]
        }

    ],
    en: [
        {
            seccion1: [
                "Business",
                "Auto-Recovery for Branch Internet",
                "Most network failures in branch offices are resolved by simply restarting the router. Our device does it automatically—without sending a technician.",
                [
                    ["Recover your branch’s security camera network", iconos[0]],
                    ["Restore the operation of your equipment", iconos[1]]
                ]
            ],
            seccion2: [
                "Home",
                "Your house is always connected, wherever you are",
                "With our smart plug, you can restart and control key devices anytime, from anywhere. Use your mobile data only when you're away from home",
                "What can you control?",
                [
                    "Security cameras: Make sure they’re always on.",
                    // "Air conditioning: Avoid failures and stay in control remotely.",
                    "Wi-Fi: Restart your network in seconds, without moving.",
                    // "Lights and lamps: Simulate presence when you're away."
                ]
            ],
            seccion3: [
                "How does it work?",
                "Just connect your devices to the smart plug. With the app, you can:",
                [
                    ["Monitor your internet connection", iconos[2]],
                    ["Ensure cameras stay online", iconos[0]],
                    ["Out-of-range voltage monitoring", iconos[3]],
                    // "Track temperature and humidity",
                    ["Get alerts if something fails", iconos[4]],
                    // "Schedule automatic restarts",
                    ["Turn devices on/off during failures", iconos[5]]
                ],
                // "Let your home work for you — no matter where you are."
            ]
        }

    ]
}
function Servicios_diseño() {
    const { language, handleLanguage } = useContext(LanguageContext);
    let info = textos[language];
    let seccion1 = info[0].seccion1;
    let seccion2 = info[0].seccion2;
    let seccion3 = info[0].seccion3;

    useEffect(() => {

    }, []);
    return (
        <div

        >
            <div className="card-detalle card-detalle-s">
                <div className='text1'>
                    <div>
                        <div style={{ background: 'transparent', fontWeight: 'bold', color: '#4D4D4D', fontSize: '15px', marginBottom: '20px', color: "#004A88" }}>{seccion1[0]}</div>
                        <div style={{ background: 'transparent', fontWeight: 'bold', color: '#63656A', fontSize: '25px', marginBottom: '20px' }}>{seccion1[1]}</div>
                        <div style={{ fontWeight: 'normal', color: '#63656A', fontSize: '20px', marginTop: '20px', marginBottom: '10px', fontSize: '15px' }}>{seccion1[2]}</div>
                        <br />
                        <div>
                            {
                                seccion1[3].map(item => {
                                    return (
                                        <>
                                            <li style={{ fontSize: '15px', color: '#63656A', listStyle: 'none', borderTop: 'solid 1px #63656A', padding: '20px' }}>
                                                {item[1]}<span style={{ fontWeight: 'bold' }}>{item[0]} </span>
                                            </li>
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className='img1 im1-s'>
                    <div className="img-keepRunning1"></div>
                </div>
            </div>
            <div className="card-detalle card-detalle-s">
                <div className='img1 im1-s'>
                    <div className="img-keepRunning2"></div>
                </div>
                <div className='text1'>
                    <div
                        style={{paddingLeft: '20px'}}
                    >
                        <div style={{ background: 'transparent', fontWeight: 'bold', color: '#4D4D4D', fontSize: '15px', marginBottom: '20px', color: "#004A88" }}>{seccion2[0]}</div>
                        <div style={{ background: 'transparent', fontWeight: 'bold', color: '#63656A', fontSize: '25px', marginBottom: '20px' }}>{seccion2[1]}</div>
                        <div style={{ fontWeight: 'normal', color: '#63656A', fontSize: '20px', marginTop: '20px', marginBottom: '10px', fontSize: '15px' }}>{seccion2[2]}</div>
                        <div style={{ background: 'transparent', fontWeight: 'bold', color: '#4D4D4D', fontSize: '15px', marginBottom: '20px', color: "#004A88" }}>{seccion2[3]}</div>
                        <div>
                            {
                                seccion2[4].map(item => {
                                    return (
                                        <>
                                            <li style={{ fontSize: '15px', color: '#63656A', listStyle: 'none', borderTop: 'solid 1px #63656A', padding: '20px' }}>
                                                <span style={{ fontSize: '20px' }}>&#9642;</span> <span style={{ fontWeight: 'bold' }}>{item.split(':')[0]} </span>: <span style={{ fontWeight: 'normal' }}>{item.split(':')[1]} </span>
                                            </li>
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-detalle card-detalle-s">
                <div className='text1'>
                    <div>
                        <div style={{ background: 'transparent', fontWeight: 'bold', color: '#4D4D4D', fontSize: '15px', marginBottom: '20px', color: "#004A88" }}>{seccion3[0]}</div>                        
                        <div style={{ fontWeight: 'normal', color: '#63656A', fontSize: '20px', marginTop: '20px', marginBottom: '10px', fontSize: '15px' }}>{seccion3[1]}</div>                        
                        <div>
                            {
                                seccion3[2].map(item => {
                                    return (
                                        <>
                                            <li style={{ fontSize: '15px', color: '#63656A', listStyle: 'none', borderTop: 'solid 1px #63656A', padding: '20px' }}>
                                                {item[1]}<span style={{ fontWeight: 'bold' }}>{item[0]} </span>
                                            </li>
                                        </>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className='img1 im1-s'>
                    <div className="img-keepRunning3"></div>
                </div>
            </div>            
        </div>
    )
}

export default Servicios_diseño;